




















































































































import Vue, { VueConstructor } from "vue";
import MainColumns from "@/components/templates/MainColumns.vue";
import { License, LicenseData, licenseConfig } from "@/models/license";
import VaNoDataTag from "@/components/molecules/VaNoDataTag.vue";
import VaBadge from "@/components/atoms/VaBadge.vue";
import VaTableTop from "@/components/molecules/VaTableTop.vue";
import validationMixin from "@/components/mixins/validationMixin";
import dataTableMixin, {
  DataTableMixin,
} from "@/components/mixins/dataTableMixin";
import VaDetailsButton from "@/components/molecules/VaDetailsButton.vue";
import Notifications from "@/components/organisms/Notifications.vue";
import NewLicenseForm from "@/components/organisms/NewLicenseForm.vue";
import { FilterBy } from "@/models/table";

export default (Vue as VueConstructor<DataTableMixin>).extend({
  name: "LicensesList",
  mixins: [validationMixin, dataTableMixin],
  components: {
    NewLicenseForm,
    VaDetailsButton,
    VaTableTop,
    MainColumns,
    VaNoDataTag,
    VaBadge,
    Notifications,
  },
  async beforeMount() {
    this.$store.commit("license/resetCurrentLicense");
  },
  data() {
    return {
      storeName: "license",
      dialog: false,
      newLicense: {
        licenseKey: "",
        isRenewal: false,
      } as LicenseData,
      tableConfig: licenseConfig,
      filterTrial: "0",
      trialOptions: [
        {
          id: "1",
          label: "Trial",
        },
        {
          id: "0",
          label: "Regular",
        },
      ],
    };
  },
  methods: {
    statusColor(license: License): string {
      switch (license.status) {
        case "active":
          return "success";
        case "inactive":
          return "error";
        case "expired":
          return "secondary";
        default:
          return "secondary";
      }
    },
  },
  computed: {
    filters(): FilterBy[] {
      let filters = [] as FilterBy[];
      if (this.filterTrial) {
        filters.push({
          field: "isTrial",
          value: this.filterTrial,
        });
      }
      return filters;
    },
  },
  watch: {
    filters: function (newVal): void {
      this.$store.dispatch("license/updateAdditionalFilters", newVal);
    },
  },
});
